'use client'
import { DataList } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'
import { memo } from 'react'

const InfoMyPositionDataListLoading = () => {
  return (
    <div className="gap-sm flex flex-col">
      <DataList.Root fullWidth>
        <DataList.Column>
          <InfoDataListLoading />
          <InfoDataListLoading />
          <InfoDataListLoading />
        </DataList.Column>

        <DataList.Column>
          <InfoDataListLoading />
          <InfoDataListLoading />
        </DataList.Column>
      </DataList.Root>
    </div>
  )
}

const InfoDataListLoading = () => (
  <DataList.Line>
    <Skeleton className="h-md w-[100%] rounded-[20px]" />
  </DataList.Line>
)

export default memo(InfoMyPositionDataListLoading)
